import React, { useState } from 'react'
import styled from 'styled-components'
import MobileSubNav from './MobileSubNav'
import { withRouter } from 'react-router-dom'
import { onClickLink } from '../common3/Link'


const Wrapper = styled.nav`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${p => p.open ? '0' : '-100%'};
  opacity: ${p => p.open ? '1' : '0'};
  width: 100%;
  padding: 20px;
  background-color: #fff;
  overflow-y: auto;
  font-size: 14px;
  transition: left 300ms;
  z-index: 100;
`

const NavSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`

const ExitIcon = styled.em`
  align-self: flex-end;
  font-size: 22px;
  cursor: pointer;
`

const NavItems = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  list-style-type: none;
  padding: 0;
`

const NavItem = styled.li`
  padding: 5px 0;
`

const NavItemText = styled.div`
  cursor: pointer;
`

const Chevron = styled.em`
  margin-left: 10px;
  transform: ${p => p.open ? 'rotate(90deg)' : 'none'};
  transition: transform 200ms;
`

Chevron.defaultProps = {
  className: 'far fa-chevron-right'
}

const Separator = styled.hr`
  margin: 10px 0;
  border: solid ${p => p.color ? p.color : '#e8e8e8'};
  border-width: 1px 0 0;
`

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Button = styled.button`
  margin-bottom: 10px;
  padding: 0;
  width: 90%;
  background-color: ${p => p.bgColor ? p.bgColor : p.theme.colors.primary ? p.theme.colors.primary : '#f5f5f5'};
  border: none;
  border-radius: 4px;
`

const ButtonInner = styled.div`
  padding: 6px 12px;
  font-size: 13px;
  color: ${p => p.color ? p.color : p.theme.colors.font ? p.theme.colors.font : '#000'};
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`

const MobileMenu = ({ user, data, open, setOpen, history }) => {
  const [selected, setSelected] = useState(null)

  const { theme, content } = data

  const sections = content.map((section, i) => {
    if (section.mobile) {
      if (section.type === 'logo') {
        return ''
      }

      if (section.type === 'nav') {
        return (
          <NavSection key={i}>
            <NavItems>
              {section.navItems.map((navItem, i) => {
                const { isAuth, enableAuth } = navItem

                if( enableAuth ) {
                  if( isAuth && ! user ) {
                    return null
                  }
  
                  if( ! isAuth && user ) {
                    return null
                  }
                }

                return (
                  navItem.mobile && (
                    <NavItem
                      key={i}
                      onClick={
                        navItem.url && !navItem.sub.length
                          ? onClickLink(navItem.url, history, () => setOpen(false))
                          : () => {  }
                      }
                    >
                      <NavItemText onClick={() => navItem.sub ? setSelected(selected => selected === i ? null : i) : selected}>
                        {navItem.heading}
                        {navItem.sub.length ? <Chevron open={selected === i} /> : ''}
                      </NavItemText>
                      {navItem.sub.length > 0 && (
                        <MobileSubNav navItem={navItem} theme={theme} index={i} selected={selected} setOpen={setOpen} />
                      )}
                      <Separator />
                    </NavItem>
                  )
                )
              })}
            </NavItems>
          </NavSection>
        )
      }

      if (section.type === 'buttons') {
        return (
          <NavSection key={i}>
            <ButtonsWrapper>
              {section.buttons.map((button, i) => (
                button.mobile && (
                  <Button key={i} bgColor={button.bgColor} >
                    <ButtonInner color={button.color}>{button.text}</ButtonInner>
                  </Button>
                )
              ))
              }
            </ButtonsWrapper>
          </NavSection >
        )
      }

      throw new Error(`MobileMenu.js can't handle type "${section.type}"`)
    }

    return ''
  })

  return (
    <Wrapper className="sp-navbar sp-navbar-mobile" open={open}>
      <NavSection>
        <ExitIcon className="fal fa-times" onClick={() => setOpen(false)} />
      </NavSection>
      {sections}
    </Wrapper>
  )
}

export default withRouter(MobileMenu)